import { api } from "./index";

export interface Vendor {
  id: string;
  email: string;
  businessName?: string | null;
  businessType?: "SOLE_PROPRIETOR" | "COMPANY" | "PARTNERSHIP" | null;
  registrationNumber?: string | null;
  taxId?: string | null;
  address?: string | null;
  phone?: string | null;
  status: "REGISTERED" | "PENDING" | "ACTIVE" | "SUSPENDED";
  createdAt: string;
  updatedAt: string;
  _count?: {
    documents: number;
    tenderRegistrations: number;
    bidSubmissions: number;
  };
}

export interface UpdateVendorDto {
  businessName?: string;
  businessType?: "SOLE_PROPRIETOR" | "COMPANY" | "PARTNERSHIP";
  registrationNumber?: string;
  taxId?: string;
  address?: string;
  phone?: string;
  password?: string;
}

export const vendorsApi = {
  getProfile: (): Promise<Vendor> => 
    api.get("/vendors/profile", { useVendorAuth: true }).then((res) => res.data),

  updateProfile: (data: UpdateVendorDto): Promise<{ vendor: Vendor; message: string }> =>
    api.put("/vendors/profile", data, { useVendorAuth: true }).then((res) => res.data),

  register: (data: {
    email: string;
    password: string;
  }): Promise<{ vendor: Vendor; message: string }> =>
    api.post("/vendors/register", data).then((res) => res.data), // Public endpoint

  login: (email: string, password: string): Promise<{ vendor: Vendor; token: string }> =>
    api.post("/vendors/login", { email, password }).then((res) => res.data), // Public endpoint

  resendVerification: (email: string): Promise<{ message: string }> =>
    api.post("/vendors/resend-verification", { email }).then((res) => res.data), // Public endpoint
  
  requestPasswordReset: (email: string): Promise<{ message: string }> =>
    api.post("/vendors/forgot-password", { email }).then((res) => res.data), // Public endpoint
  
  resetPassword: (token: string, password: string): Promise<{ message: string }> =>
    api.post("/vendors/reset-password", { token, password }).then((res) => res.data), // Public endpoint

  checkProfileReady: (): Promise<{ isReady: boolean }> =>
    api.get("/vendors/profile/ready", { useVendorAuth: true }).then((res) => res.data),

  submitForApproval: (): Promise<{ vendor: Vendor; message: string }> =>
    api.post("/vendors/profile/submit-for-approval", undefined, { useVendorAuth: true }).then((res) => res.data),
};

